export default {
    mounted() {
        this.addClickOutside()
    },

    methods: {
        addClickOutside() {
            document.addEventListener('click', this.handleClickOutside, true)
        },

        clickOutsideHandler() {},

        handleClickOutside(e) {
            const el = this.$el

            if (!el.contains(e.target)) {
                this.clickOutsideHandler()
            }
        },
    },

    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside, true)
    },
}